<template>
    <div v-if="query" class="admin-show-query">
        <VJoyButton icon="eye" label="Show query" variant="admin" size="xxsmall" class="joy-ml-1" @click="dialog?.show()" />
        <VJoyButton icon="copy" label="Copy query" variant="admin" size="xxsmall" class="joy-ml-1" @click="copy(`${operation}\n${prettyQuery}`)" />
        <VJoyDialog ref="dialog" size="large" title="Query">
            <template #dialog-header>Query</template>
            <template #dialog-body>
                <div class="admin-show-query-dialog-content operation">{{ operation }}</div>
                <div class="admin-show-query-dialog-content query">{{ prettyQuery }}</div>
            </template>
        </VJoyDialog>
    </div>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {useClipboard} from '@vueuse/core';
    import {VJoyButton, VJoyDialog} from '@maltjoy/core-vue';

    const props = defineProps<{
        query?: string;
    }>();

    const {copy} = useClipboard({legacy: true});

    const dialog = ref<InstanceType<typeof VJoyDialog>>();

    const queryParts = computed(() => /^SearchRequest: (?<operation>.*) (?<query>{.*})$/.exec(props.query ?? '')?.groups);
    const operation = computed(() => queryParts.value?.operation);
    const prettyQuery = computed(() => prettifyJson(queryParts.value?.query ?? ''));

    function prettifyJson(jsonString: string) {
        try {
            const jsonObject = JSON.parse(queryParts.value?.query ?? '{}');
            return JSON.stringify(jsonObject, null, 2);
        } catch (_) {
            return jsonString;
        }
    }
</script>

<style scoped lang="scss">
    .admin-show-query {
        display: inline;

        &-dialog-content {
            font-size: var(--joy-font-size-primary-200);
            font-family: monospace;

            &.query {
                white-space: pre-wrap;
            }
        }
    }
</style>
